import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import { useEffect, useState, useContext } from "react";
import { useKeenSlider } from "keen-slider/react";
import Slide from "../Atomics/Slide/Slide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { SidebarContext } from "../../context/sidebar";

export default function VideoBlock({ data, nameInView, type }) {
  const [sliderInstance, setSliderInstance] = useState(null);
  const { showMenu } = useContext(SidebarContext);
  const [ref, slider] = useKeenSlider({
    loop: true,
    mode: "snap",
    slides: {
      perView: 6,
      spacing: 15,
    },
    breakpoints: {
      "(max-width: 1250px)": {
        slides: { perView: 4, spacing: 10 },
      },
      "(max-width: 1040px)": {
        slides: { perView: 3, spacing: 10 },
      },
      "(max-width: 843px)": {
        slides: { perView: 2, spacing: 10 },
      },
      "(max-width: 423px)": {
        slides: { perView: 1, spacing: 10 },
      },
    },
    created(s) {
      setSliderInstance(s);
    },
  });

  // Auto-advance slider
  useEffect(() => {
    const interval = setInterval(() => {
      sliderInstance?.next();
    }, 8000);
    return () => clearInterval(interval);
  }, [sliderInstance]);

  // Watch for sidebar toggle and update slider
  useEffect(() => {
    if (!sliderInstance || !ref.current) return;

    // Use ResizeObserver to detect container width changes
    const resizeObserver = new ResizeObserver(() => {
      sliderInstance.update();
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [sliderInstance, ref]);

  // Update slider when sidebar state changes
  useEffect(() => {
    if (sliderInstance) {
      // Small delay to allow CSS transition to complete
      const timer = setTimeout(() => {
        sliderInstance.update();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showMenu, sliderInstance]);

  return (
    <div className="videoBlockBG" style={{ minHeight: "200px" }}>
      <div className="video-block section-padding">
        <Row>
          <Col md={12}>
            <SectionHeader heading={nameInView} />
          </Col>
        </Row>

        <Row className="gx-3 gy-4">
          <div
            className="slider-wrapper"
            style={{ position: "relative", width: "100%", padding: "0px 5px" }}
          >
            <div ref={ref} className="keen-slider">
              {data?.content_items?.map((item, index) => (
                <div className="keen-slider__slide" key={index}>
                  <Slide
                    href={
                      type === "channel"
                        ? `/single-channel/${item?.id}`
                        : `/video-page/${item?.id}/`
                    }
                    imgSrc={item.avatar}
                    label={item.name}
                    views={
                      type === "channel"
                        ? item.counted_view
                        : item.counted_views
                    }
                    type="video"
                    videoCover={item.cover}
                    videoTitle={item.title}
                    videoCategory={item.categorys.name}
                    videoCountedViews={item.counted_views}
                    videoPublishedDate={item.published_date}
                    viedoChannelName={item.channel.name}
                    videoChannelId={item.channel.id}
                    videoId={item.id}
                  />
                </div>
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              className="custom-slick-btn custom-slick-prev"
              style={{
                position: "absolute",
                left: "6px",
                top: "40%",
                zIndex: 2,
              }}
              onClick={() => sliderInstance?.prev()}
            >
              <FontAwesomeIcon
                icon={faAngleLeft}
                mask={faCircle}
                transform="shrink-7"
              />
            </button>

            <button
              className="custom-slick-btn custom-slick-next"
              style={{
                position: "absolute",
                right: "6px",
                top: "40%",
                zIndex: 2,
              }}
              onClick={() => sliderInstance?.next()}
            >
              <FontAwesomeIcon
                icon={faAngleRight}
                mask={faCircle}
                transform="shrink-7"
              />
            </button>
          </div>
        </Row>
      </div>
    </div>
  );
}
